module.exports = __webpack_public_path__ + "media/img/home/product/product2-c844cb77f8ae7922de42d3fb2003901e.svg";